const visitTypes = {
  FETCH_VISIT_RECORDS: 'FETCH_VISIT_RECORDS',
  SET_VISIT_RECORDS: 'SET_VISIT_RECORDS',
  FETCH_VISIT_DETAILS: 'FETCH_VISIT_DETAILS',
  UPDATE_RESULT_STATUS: 'UPDATE_RESULT_STATUS'
};

export default visitTypes;
